<template>
  <v-container class="main-container responsive-height create-investor-account-wrapper">
    <v-row class="mb-2">
      <v-col cols="12">
        <div class="middle-bar">
          <div class="titleName mb-1">
            <v-icon class="mr-2" color="#5F7692">mdi-bag-checked</v-icon>
            <span class="text--ash">Select Account Type : General or Trademaster</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col lg="12" class="mb-2">
        <v-card
          class="elevation-0 rounded-0 open-investor-card"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'"
        >
          <div class="card-image">
            <img alt="general" width="69" height="67" src="@/assets/general.png" />
            <div class="content">
              <h3>General Investor Account</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur. Tincidunt id amet sem iaculis in.
                Est morbi eu bibendum nunc a vivamus vestibulum. Sed nibh mauris morbi.
              </p>
            </div>
          </div>
          <v-btn
            class="btn-account text-capitalize"
            elevation="0"
            tile
            color="#039de9"
            large
            to="/create-investor-account?type=general"
            >Select General Type</v-btn
          >
        </v-card>
      </v-col>
      <v-col lg="12">
        <v-card
          class="elevation-0 rounded-0 open-investor-card"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'"
        >
          <div class="card-image">
            <img alt="general" width="69" height="67" src="@/assets/trademaster.png" />
            <div class="content">
              <h3>Trade Master Investor Account</h3>
              <p>
                Here you can trade as like your manager opens trade volume, or you can
                select as you want, like 2x, 3x, 4x, 5x
              </p>
            </div>
          </div>
          <v-btn
            class="btn-account text-capitalize"
            elevation="0"
            tile
            color="#039de9"
            large
            to="/create-investor-account?type=trademaster"
            >Select Trademaster Type</v-btn
          >
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>
